import { PATH, OPEN_ALL, OPEN_ORG, OPEN_SITE, FORBID_ALL } from "./const"; //** PATH is Required!!! */

//** Required */
import Login from "pages/Login";
import Layout from "ui/Layout";

// Dashboard
import Dashboard from "pages/Dashboard";

// Monitor

// Configure

// Reports

// Setting
import LicenseManagement from "pages/Settings/LicenseManagement";
import LicenseHistory from "pages/Settings/LicenseManagement/LicenseHistory";
import AccountManagement from "pages/Settings/AccountManagement";
import SamlConfiguration from "pages/Settings/AdvancedSettings/SamlConfiguration";
import SmsConfiguration from "pages/Settings/AdvancedSettings/SmsConfiguration";
import SyslogServerConfiguration from "pages/Settings/AdvancedSettings/SyslogServerConfiguration";
import OrgManagement from "pages/Settings/OrganizationManagement/OrgManagement";
import OrgTree from "pages/Settings/OrganizationManagement/OrgTree";

// Other
import UserProfile from "pages/UserProfile";

import Error from "pages/Error";

//** Required */
export const routeList = {
  login: [
    {
      path: PATH.login,
      element: <Login />,
      publicRouter: true, // default = false
    }
  ],
  user_profile: [
    {
      path: PATH.user_profile,
      element: <UserProfile />,
    },
  ],
  dashboard: [
    {
      path: PATH.dashboard.dashboard,
      element: <Dashboard />,
      // loader: ({ request, params }) => {
      //   // dynamic /settings/.../:id > params.id
      //   const ex = { A: "a" };
      //   return ex; // option: import { useLoaderData } from "react-router-dom";  for page
      // }
    },
  ],
  monitor: [],
  congigure: [],
  reports: [],
  settings: [
    {
      path: PATH.settings.account,
      element: <AccountManagement />,
    },
    {
      path: PATH.settings.license_management,
      element: <LicenseManagement />,
    },
    {
      path: PATH.settings.license_history,
      element: <LicenseHistory />,
    },
    {
      path: PATH.settings.saml_configuration,
      element: <SamlConfiguration />,
    },
    {
      path: PATH.settings.sms_configuration,
      element: <SmsConfiguration />,
    },
    {
      path: PATH.settings.syslog_server_configuration,
      element: <SyslogServerConfiguration />,
    },
    {
      path: PATH.settings.organization,
      element: <OrgManagement />,
    },
    {
      path: PATH.settings.organization_id,
      element: <OrgTree />,
    },

  ],
  help: [],
  terms: [],
  privacy: [],
};

//** Required */
export const defaultRouteRule = {
  SP: {
    [PATH.user_profile]: FORBID_ALL,
    [PATH.reports.licenses]: FORBID_ALL,
    [PATH.settings.account]: OPEN_ORG,
    [PATH.settings.organization]: FORBID_ALL,
    [PATH.terms]: FORBID_ALL,
    [PATH.privacy]: FORBID_ALL,
    [PATH.help.announcements]: FORBID_ALL,
  },
  SI: {
    [PATH.user_profile]: FORBID_ALL,
    [PATH.dashboard.dashboard]: OPEN_ALL,
    [PATH.dashboard.network_view]: FORBID_ALL,
    "/MONITOR/AP/DEVICES": OPEN_ALL,
    "/MONITOR/AP/CLIENTS": "",
    "/MONITOR/AP/EVENT-LOGS": "",
    "/MONITOR/SWITCH/DEVICES": "",
    "/MONITOR/SWITCH/CLIENTS": "",
    "/MONITOR/SWITCH/EVENT-LOGS": "",
    "/MONITOR/GATEWAY/DEVICES": "",
    "/MONITOR/GATEWAY/CLIENTS": "",
    "/MONITOR/GATEWAY/EVENT-LOGS": "",
    "/MONITOR/MAP": "",
    "/MONITOR/FLOOR-PLAN": "",
    "/MONITOR/FLOOR-PLAN/:ID": "",
    "/MONITOR/NEIGHBOR-AP": "",
    "/CONFIGURE/AP/AP-PROFILE": "",
    "/CONFIGURE/AP/AP-PROFILE/:PROFILE_ID/": "",
    "/CONFIGURE/AP/DEVICE": "",
    "/CONFIGURE/AP/DEVICE/:ID": "",
    "/CONFIGURE/AP/IP-ACLS": "",
    "/CONFIGURE/AP/LDAP-SERVERS": "",
    "/CONFIGURE/AP/RADIUS-SERVERS": "",
    "/CONFIGURE/MAC-ACLS": "",
    "/CONFIGURE/WALLED-GARDEN": "",
    "/CONFIGURE/SWITCH/PROFILES": "",
    "/CONFIGURE/SWITCH/SWITCH-PROFILE": "",
    "/CONFIGURE/SWITCH/SWITCH-PORTS": "",
    "/CONFIGURE/SWITCH/SWITCH-PROFILE/:PROFILE_ID/": "",
    "/CONFIGURE/SWITCH/DEVICES": "",
    "/CONFIGURE/SWITCH/DEVICE/:ID": "",
    "/CONFIGURE/GATEWAY/GATEWAY-PROFILE": "",
    "/CONFIGURE/GATEWAY/GATEWAY-PROFILE/:PROFILE_ID/": "",
    "/CONFIGURE/GATEWAY/DEVICES": "",
    "/CONFIGURE/GATEWAY/DEVICE/:ID": "",
    "/CONFIGURE/SCHEDULE-POLICIES": "",
    "/CONFIGURE/SPLASH-PAGE": "",
    "/CONFIGURE/SPLASH-PAGE/EDIT": "",
    "/CONFIGURE/AUTHENTICATION/AUTHENTICATION-SERVERS": "",
    "/CONFIGURE/AUTHENTICATION/LOCAL-AUTHENTICATION-LIST": "",
    [PATH.reports.change_log]: "",
    [PATH.reports.summary_report]: "",
    [PATH.reports.alerts]: "",
    [PATH.reports.licenses]: OPEN_ORG,
    [PATH.settings.account]: OPEN_ORG,
    [PATH.settings.organization]: FORBID_ALL,
    [PATH.settings.organization_id]: FORBID_ALL,
    [PATH.settings.license_management]: OPEN_ORG,
    [PATH.settings.license_history]: OPEN_ORG,
    "/SETTINGS/FIRMWARE": "",
    "/SETTINGS/ALERT-SETTINGS": "",
    "/SETTINGS/CERTIFICATE-MANAGEMENT": "",
    [PATH.settings.saml_configuration]: OPEN_ORG,
    [PATH.settings.sms_configuration]: OPEN_ORG,
    [PATH.settings.syslog_server_configuration]: OPEN_ORG,
    "/SETTINGS/BULK-IMPORT-DEVICES": "",
    // '/SETTINGS/BULK-CONFIGURATION-GW': '',
    // PATH.setting.bulkConfigurationAp: '',
    [PATH.terms]: FORBID_ALL,
    [PATH.privacy]: FORBID_ALL,
    [PATH.help.announcements]: FORBID_ALL,
    "/HELP/CONTACT-TECHNICAL-SUPPORT": "",
    "/HELP/TROUBLESHOOTING": "",
  },
  ORG_MANAGER: {
    [PATH.user_profile]: FORBID_ALL,
    [PATH.dashboard.dashboard]: OPEN_SITE,
    "/MONITOR/AP/DEVICES": "",
    "/MONITOR/AP/CLIENTS": "",
    "/MONITOR/AP/EVENT-LOGS": "",
    "/MONITOR/SWITCH/DEVICES": "",
    "/MONITOR/SWITCH/CLIENTS": "",
    "/MONITOR/SWITCH/EVENT-LOGS": "",
    "/MONITOR/GATEWAY/DEVICES": "",
    "/MONITOR/GATEWAY/CLIENTS": "",
    "/MONITOR/GATEWAY/EVENT-LOGS": "",
    "/MONITOR/MAP": "",
    "/MONITOR/FLOOR-PLAN": "",
    "/MONITOR/FLOOR-PLAN/:ID": "",
    "/MONITOR/NEIGHBOR-AP": "",
    "/CONFIGURE/AP/AP-PROFILE": "",
    "/CONFIGURE/AP/AP-PROFILE/:PROFILE_ID/": "",
    "/CONFIGURE/AP/DEVICE": "",
    "/CONFIGURE/AP/DEVICE/:ID": "",
    "/CONFIGURE/AP/IP-ACLS": "",
    "/CONFIGURE/AP/LDAP-SERVERS": "",
    "/CONFIGURE/AP/RADIUS-SERVERS": "",
    "/CONFIGURE/MAC-ACLS": "",
    "/CONFIGURE/WALLED-GARDEN": "",
    "/CONFIGURE/SWITCH/PROFILES": "",
    "/CONFIGURE/SWITCH/SWITCH-PROFILE": "",
    "/CONFIGURE/SWITCH/SWITCH-PORTS": "",
    "/CONFIGURE/SWITCH/SWITCH-PROFILE/:PROFILE_ID/": "",
    "/CONFIGURE/SWITCH/DEVICES": "",
    "/CONFIGURE/SWITCH/DEVICE/:ID": "",
    "/CONFIGURE/GATEWAY/GATEWAY-PROFILE": "",
    "/CONFIGURE/GATEWAY/GATEWAY-PROFILE/:PROFILE_ID/": "",
    "/CONFIGURE/GATEWAY/DEVICES": "",
    "/CONFIGURE/GATEWAY/DEVICE/:ID": "",
    "/CONFIGURE/SCHEDULE-POLICIES": "",
    "/CONFIGURE/SPLASH-PAGE": "",
    "/CONFIGURE/SPLASH-PAGE/EDIT": "",
    "/CONFIGURE/AUTHENTICATION/AUTHENTICATION-SERVERS": "",
    "/CONFIGURE/AUTHENTICATION/LOCAL-AUTHENTICATION-LIST": "",
    [PATH.reports.change_log]: FORBID_ALL,
    [PATH.reports.summary_report]: FORBID_ALL,
    [PATH.reports.alerts]: "",
    [PATH.reports.licenses]: FORBID_ALL,
    [PATH.settings.account]: FORBID_ALL,
    [PATH.settings.organization]: FORBID_ALL,
    [PATH.settings.organization_id]: FORBID_ALL,
    [PATH.settings.license_management]: FORBID_ALL,
    [PATH.settings.license_history]: FORBID_ALL,
    "/SETTINGS/FIRMWARE": "",
    "/SETTINGS/ALERT-SETTINGS": "",
    "/SETTINGS/CERTIFICATE-MANAGEMENT": "",
    [PATH.settings.saml_configuration]: FORBID_ALL,
    [PATH.settings.sms_configuration]: FORBID_ALL,
    [PATH.settings.syslog_server_configuration]: FORBID_ALL,
    "/SETTINGS/BULK-IMPORT-DEVICES": "",
    [PATH.terms]: FORBID_ALL,
    [PATH.privacy]: FORBID_ALL,
    [PATH.help.announcements]: FORBID_ALL,
    "/HELP/CONTACT-TECHNICAL-SUPPORT": "",
    "/HELP/TROUBLESHOOTING": "",
  },
  TAG_MANAGER: {
    [PATH.user_profile]: FORBID_ALL,
    [PATH.dashboard.dashboard]: OPEN_SITE,
    "/MONITOR/AP/DEVICES": "",
    "/MONITOR/AP/CLIENTS": "",
    "/MONITOR/AP/EVENT-LOGS": "",
    "/MONITOR/SWITCH/DEVICES": "",
    "/MONITOR/SWITCH/CLIENTS": "",
    "/MONITOR/SWITCH/EVENT-LOGS": "",
    "/MONITOR/GATEWAY/DEVICES": "",
    "/MONITOR/GATEWAY/CLIENTS": "",
    "/MONITOR/GATEWAY/EVENT-LOGS": "",
    "/MONITOR/MAP": "",
    "/MONITOR/FLOOR-PLAN": "",
    "/MONITOR/FLOOR-PLAN/:ID": "",
    "/MONITOR/NEIGHBOR-AP": "",
    "/CONFIGURE/AP/AP-PROFILE": "",
    "/CONFIGURE/AP/AP-PROFILE/:PROFILE_ID/": "",
    "/CONFIGURE/AP/DEVICE": "",
    "/CONFIGURE/AP/DEVICE/:ID": "",
    "/CONFIGURE/AP/IP-ACLS": "",
    "/CONFIGURE/AP/LDAP-SERVERS": "",
    "/CONFIGURE/AP/RADIUS-SERVERS": "",
    "/CONFIGURE/MAC-ACLS": "",
    "/CONFIGURE/WALLED-GARDEN": "",
    "/CONFIGURE/SWITCH/PROFILES": "",
    "/CONFIGURE/SWITCH/SWITCH-PROFILE": "",
    "/CONFIGURE/SWITCH/SWITCH-PORTS": "",
    "/CONFIGURE/SWITCH/SWITCH-PROFILE/:PROFILE_ID/": "",
    "/CONFIGURE/SWITCH/DEVICES": "",
    "/CONFIGURE/SWITCH/DEVICE/:ID": "",
    "/CONFIGURE/GATEWAY/GATEWAY-PROFILE": "",
    "/CONFIGURE/GATEWAY/GATEWAY-PROFILE/:PROFILE_ID/": "",
    "/CONFIGURE/GATEWAY/DEVICES": "",
    "/CONFIGURE/GATEWAY/DEVICE/:ID": "",
    "/CONFIGURE/SCHEDULE-POLICIES": "",
    "/CONFIGURE/SPLASH-PAGE": "",
    "/CONFIGURE/SPLASH-PAGE/EDIT": "",
    "/CONFIGURE/AUTHENTICATION/AUTHENTICATION-SERVERS": "",
    "/CONFIGURE/AUTHENTICATION/LOCAL-AUTHENTICATION-LIST": "",
    [PATH.reports.change_log]: "",
    [PATH.reports.summary_report]: "",
    [PATH.reports.alerts]: "",
    [PATH.settings.account]: FORBID_ALL,
    [PATH.settings.organization]: FORBID_ALL,
    [PATH.settings.organization_id]: FORBID_ALL,
    "/SETTINGS/FIRMWARE": "",
    "/SETTINGS/ALERT-SETTINGS": "",
    "/SETTINGS/CERTIFICATE-MANAGEMENT": "",
    [PATH.settings.sms_configuration]: FORBID_ALL,
    [PATH.terms]: FORBID_ALL,
    [PATH.privacy]: FORBID_ALL,
    [PATH.help.announcements]: FORBID_ALL,
    "/HELP/CONTACT-TECHNICAL-SUPPORT": "",
    "/HELP/TROUBLESHOOTING": "",
  },
  STORE_MANAGER: {
    [PATH.user_profile]: FORBID_ALL,
    [PATH.dashboard.dashboard]: FORBID_ALL,
    "/MONITOR/AP/DEVICES": FORBID_ALL,
    "/MONITOR/AP/CLIENTS": FORBID_ALL,
    "/MONITOR/AP/EVENT-LOGS": FORBID_ALL,
    "/MONITOR/SWITCH/DEVICES": FORBID_ALL,
    "/MONITOR/SWITCH/CLIENTS": FORBID_ALL,
    "/MONITOR/SWITCH/EVENT-LOGS": FORBID_ALL,
    "/MONITOR/GATEWAY/DEVICES": FORBID_ALL,
    "/MONITOR/GATEWAY/CLIENTS": FORBID_ALL,
    "/MONITOR/GATEWAY/EVENT-LOGS": FORBID_ALL,
    "/MONITOR/MAP": FORBID_ALL,
    "/MONITOR/FLOOR-PLAN": FORBID_ALL,
    "/MONITOR/FLOOR-PLAN/:ID": FORBID_ALL,
    "/MONITOR/NEIGHBOR-AP": FORBID_ALL,
    "/CONFIGURE/AP/AP-PROFILE": FORBID_ALL,
    "/CONFIGURE/AP/AP-PROFILE/:PROFILE_ID/": FORBID_ALL,
    "/CONFIGURE/AP/DEVICE": FORBID_ALL,
    "/CONFIGURE/AP/DEVICE/:ID": FORBID_ALL,
    "/CONFIGURE/AP/IP-ACLS": FORBID_ALL,
    "/CONFIGURE/AP/LDAP-SERVERS": FORBID_ALL,
    "/CONFIGURE/AP/RADIUS-SERVERS": FORBID_ALL,
    "/CONFIGURE/MAC-ACLS": FORBID_ALL,
    "/CONFIGURE/WALLED-GARDEN": FORBID_ALL,
    "/CONFIGURE/SWITCH/PROFILES": FORBID_ALL,
    "/CONFIGURE/SWITCH/SWITCH-PROFILE": FORBID_ALL,
    "/CONFIGURE/SWITCH/SWITCH-PORTS": FORBID_ALL,
    "/CONFIGURE/SWITCH/SWITCH-PROFILE/:PROFILE_ID/": FORBID_ALL,
    "/CONFIGURE/SWITCH/DEVICES": FORBID_ALL,
    "/CONFIGURE/SWITCH/DEVICE/:ID": FORBID_ALL,
    "/CONFIGURE/GATEWAY/GATEWAY-PROFILE": FORBID_ALL,
    "/CONFIGURE/GATEWAY/GATEWAY-PROFILE/:PROFILE_ID/": FORBID_ALL,
    "/CONFIGURE/GATEWAY/DEVICES": FORBID_ALL,
    "/CONFIGURE/GATEWAY/DEVICE/:ID": FORBID_ALL,
    "/CONFIGURE/SCHEDULE-POLICIES": FORBID_ALL,
    "/CONFIGURE/SPLASH-PAGE": FORBID_ALL,
    "/CONFIGURE/SPLASH-PAGE/EDIT": FORBID_ALL,
    "/CONFIGURE/AUTHENTICATION/AUTHENTICATION-SERVERS": FORBID_ALL,
    "/CONFIGURE/AUTHENTICATION/LOCAL-AUTHENTICATION-LIST": FORBID_ALL,
    [PATH.reports.change_log]: FORBID_ALL,
    [PATH.reports.summary_report]: FORBID_ALL,
    [PATH.reports.alerts]: FORBID_ALL,
    [PATH.settings.account]: FORBID_ALL,
    [PATH.settings.organization]: FORBID_ALL,
    [PATH.settings.organization_id]: FORBID_ALL,
    "/SETTINGS/FIRMWARE": FORBID_ALL,
    "/SETTINGS/ALERT-SETTINGS": FORBID_ALL,
    "/SETTINGS/CERTIFICATE-MANAGEMENT": FORBID_ALL,
    [PATH.settings.sms_configuration]: FORBID_ALL,
    [PATH.terms]: FORBID_ALL,
    [PATH.privacy]: FORBID_ALL,
    [PATH.help.announcements]: FORBID_ALL,
    "/HELP/CONTACT-TECHNICAL-SUPPORT": FORBID_ALL,
    "/HELP/TROUBLESHOOTING": FORBID_ALL,
  },
};

//** Required */
// only for URL redirect privilege
export const privilegeRouteRule = {
  EDITOR: [
    PATH.user_profile,
    PATH.dashboard.dashboard,
    PATH.dashboard.network_view,
    "/MONITOR/AP/DEVICES",
    "/MONITOR/AP/CLIENTS",
    "/MONITOR/AP/EVENT-LOGS",
    "/MONITOR/SWITCH/DEVICES",
    "/MONITOR/SWITCH/CLIENTS",
    "/MONITOR/SWITCH/EVENT-LOGS",
    "/MONITOR/GATEWAY/DEVICES",
    "/MONITOR/GATEWAY/CLIENTS",
    "/MONITOR/GATEWAY/EVENT-LOGS",
    "/MONITOR/MAP",
    "/MONITOR/FLOOR-PLAN",
    "/MONITOR/FLOOR-PLAN/:ID",
    "/MONITOR/NEIGHBOR-AP",
    "/CONFIGURE/AP/AP-PROFILE",
    "/CONFIGURE/AP/AP-PROFILE/:PROFILE_ID/",
    "/CONFIGURE/AP/DEVICE",
    "/CONFIGURE/AP/DEVICE/:ID",
    "/CONFIGURE/AP/IP-ACLS",
    "/CONFIGURE/AP/LDAP-SERVERS",
    "/CONFIGURE/AP/RADIUS-SERVERS",
    "/CONFIGURE/AP/SPLASH-PAGE",
    "/CONFIGURE/MAC-ACLS",
    "/CONFIGURE/WALLED-GARDEN",
    "/CONFIGURE/SWITCH/PROFILES",
    "/CONFIGURE/SWITCH/SWITCH-PROFILE",
    "/CONFIGURE/SWITCH/SWITCH-PORTS",
    "/CONFIGURE/SWITCH/SWITCH-PROFILE/:PROFILE_ID/",
    "/CONFIGURE/SWITCH/DEVICES",
    "/CONFIGURE/SWITCH/DEVICE/:ID",
    "/CONFIGURE/GATEWAY/DEVICE/:ID",
    "/CONFIGURE/GATEWAY/GATEWAY-PROFILE",
    "/CONFIGURE/GATEWAY/GATEWAY-PROFILE/:PROFILE_ID/",
    "/CONFIGURE/GATEWAY/DEVICES",
    "/CONFIGURE/AUTHENTICATION/AUTHENTICATION-SERVERS",
    "/CONFIGURE/AUTHENTICATION/LOCAL-AUTHENTICATION-LIST",
    "/CONFIGURE/SCHEDULE-POLICIES",
    "/CONFIGURE/SPLASH-PAGE",
    "/CONFIGURE/SPLASH-PAGE/EDIT",
    PATH.reports.change_log,
    PATH.reports.summary_report,
    PATH.reports.alerts,
    PATH.reports.licenses,
    PATH.settings.account,
    PATH.settings.organization,
    PATH.settings.organization_id,
    PATH.settings.license_management,
    PATH.settings.license_history,
    "/SETTINGS/FIRMWARE",
    "/SETTINGS/ALERT-SETTINGS",
    "/SETTINGS/CERTIFICATE-MANAGEMENT",
    "/SETTINGS/ADVANCED-SETTINGS/SMS-CONFIGURATION",
    "/SETTINGS/ADVANCED-SETTINGS/SYSLOG-CONFIGURATION",
    PATH.terms,
    PATH.privacy,
    PATH.help.announcements,
    "/HELP/CONTACT-TECHNICAL-SUPPORT",
    "/HELP/TROUBLESHOOTING",
  ],
  MONITOR: [
    PATH.user_profile,
    PATH.dashboard.dashboard,
    PATH.dashboard.network_view,
    "/MONITOR/AP/DEVICES",
    "/MONITOR/AP/CLIENTS",
    "/MONITOR/AP/EVENT-LOGS",
    "/MONITOR/SWITCH/DEVICES",
    "/MONITOR/SWITCH/CLIENTS",
    "/MONITOR/SWITCH/EVENT-LOGS",
    "/MONITOR/GATEWAY/DEVICES",
    "/MONITOR/GATEWAY/CLIENTS",
    "/MONITOR/GATEWAY/EVENT-LOGS",
    "/MONITOR/MAP",
    "/MONITOR/FLOOR-PLAN",
    "/MONITOR/FLOOR-PLAN/:ID",
    "/MONITOR/NEIGHBOR-AP",
    "/CONFIGURE/AP/DEVICE/:ID",
    "/CONFIGURE/SWITCH/DEVICE/:ID",
    "/CONFIGURE/GATEWAY/DEVICE/:ID",
    PATH.reports.change_log,
    PATH.reports.summary_report,
    PATH.reports.alerts,
    PATH.reports.licenses,
    PATH.settings.license_management,
    PATH.settings.license_history,
    "/SETTINGS/ALERT-SETTINGS",
    "/SETTINGS/CERTIFICATE-MANAGEMENT",
    PATH.terms,
    PATH.privacy,
  ],
  VIEWER: [
    PATH.user_profile,
    PATH.dashboard.dashboard,
    PATH.dashboard.network_view,
    "/MONITOR/AP/DEVICES",
    "/MONITOR/AP/CLIENTS",
    "/MONITOR/AP/EVENT-LOGS",
    "/MONITOR/SWITCH/DEVICES",
    "/MONITOR/SWITCH/CLIENTS",
    "/MONITOR/SWITCH/EVENT-LOGS",
    "/MONITOR/GATEWAY/DEVICES",
    "/MONITOR/GATEWAY/CLIENTS",
    "/MONITOR/GATEWAY/EVENT-LOGS",
    "/MONITOR/MAP",
    "/MONITOR/FLOOR-PLAN",
    "/MONITOR/FLOOR-PLAN/:ID",
    "/MONITOR/NEIGHBOR-AP",
    "/CONFIGURE/AP/DEVICE/:ID",
    "/CONFIGURE/SWITCH/DEVICE/:ID",
    "/CONFIGURE/GATEWAY/DEVICE/:ID",
    PATH.terms,
    PATH.privacy,
  ],
};

export const rootElement = {
  path: "/",
  element: <Layout />,
  errorElement: <Error />,
  // loader: ({ request, params }) => {
  //   const currentPath = window.location.pathname;
  //   if (currentPath === "/") {

  //     // window.location.replace(PATH.dashboard.dashboard); //????
  //   }
  // },
  children: [],
};
